import React from "react";
import { Typography } from "@mui/material";

const AccessDeniedPanel = () => {
  return (
    <Typography
      sx={{
        my: ["0.25rem", "0.25rem", "0.25rem", "0.25rem", "0.5rem", "0.5rem"],
        fontSize: [
          "1.25rem",
          "1.25rem",
          "1.25rem",
          "1.25rem",
          "1.75rem",
          "1.75rem",
        ],
        color: "red",
      }}
    >
      Access Denied
    </Typography>
  );
};

export default AccessDeniedPanel;
